import { actions, store } from "../../redux";
import PostGIFProps from "../../redux/slices/postGIF/postGIF";
import { API_INSTANCES } from "../api_instance";
import { handleError } from "../errors";

const dispatch = store.dispatch;

const getPostGIF = (gif_id: string) =>
  API_INSTANCES.POSTGIF.getPostGIF(gif_id)
    .then((res) => console.log(res.data))
    .catch((error) => handleError(error, "getPostGIF"));

const uploadGIFForAPost = (payload: PostGIFProps.UploadGIFForAPostPayload) =>
  API_INSTANCES.POSTGIF.uploadGIFForAPost(payload)
    .then((res) => {
      const data = res.data as PostGIFProps.PostGIF;
      dispatch(actions.postGIF.setPostGIF(data));
    })
    .catch((error) => handleError(error, "uploadGIFForAPost"));

const deleteGIFForAPost = (payload: PostGIFProps.DeleteGIFForAPostPayload) =>
  API_INSTANCES.POSTGIF.deleteGIFForAPost(payload)
    .then(() => dispatch(actions.postGIF.reset()))
    .catch((error) => handleError(error, "deleteGIFForAPost"));

export const POSTGIF = { getPostGIF, uploadGIFForAPost, deleteGIFForAPost };
